import { render, staticRenderFns } from "./per_item.vue?vue&type=template&id=2a1beef0"
import script from "./per_item.vue?vue&type=script&lang=ts"
export * from "./per_item.vue?vue&type=script&lang=ts"
import style0 from "./per_item.vue?vue&type=style&index=0&id=2a1beef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports